import React from "react";
import PropTypes from "prop-types";
import { Lock, Shield } from "lucide-react";

/**
 * Protect PII Button Component
 * Fixed bottom button for applying protection modes
 */
export const ProtectPIIButton = ({
  selectedColumnsCount,
  selectedRegion,
  regionsData,
  onProtectClick,
}) => {
  if (selectedColumnsCount === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 fixed bottom-6 left-24 right-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5 text-purple-600" />
          <div>
            <p className="text-sm font-semibold text-gray-800">
              {selectedColumnsCount} column
              {selectedColumnsCount > 1 ? "s" : ""} selected
            </p>
            <p className="text-xs text-gray-600">
              Ready to apply protection methods
            </p>
          </div>
        </div>
        <button
          onClick={onProtectClick}
          className="px-6 py-2.5 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2 whitespace-nowrap"
        >
          <Lock className="w-4 h-4 flex-shrink-0" />
          {(() => {
            const regionObj = regionsData.find(
              (r) => (r.region_code || r.code) === selectedRegion,
            );
            const frameworks = regionObj?.compliance_frameworks || [];
            return frameworks.length > 0 ? (
              <span className="text-sm font-semibold">
                Protect {frameworks.join(" | ")}
              </span>
            ) : (
              <span className="text-sm font-semibold">Protect PII</span>
            );
          })()}
        </button>
      </div>
    </div>
  );
};

ProtectPIIButton.propTypes = {
  selectedColumnsCount: PropTypes.number.isRequired,
  selectedRegion: PropTypes.string.isRequired,
  regionsData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onProtectClick: PropTypes.func.isRequired,
};
